import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

/*Actions*/
import {
	getDocuments,
	getPriceSheet
} from '../../../../redux/actions';
import GeneratePriceSheetDialog  from '../../../dialogs/generatePriceSheetDialog';
import ConfirmationPriceSheetDialog from '../../../dialogs/confirmationPriceSheetDialog';
import { SA_TEMPLATE_MAPPING } from '../../../common/priceTemplateMapping';

class PriceSheets extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			selectedSA: "",
			priceSheets:[],
			showGeneratePriceSheetDialog: false,
			showConfirmationDialog: false,
  			selectedPriceSheet: null,
			selectedAgreementName:''
		}
	}

	componentDidMount() {
		const user = this.props.state.user;
		const sessionSA = user && user.selectedPriceSource;
		let allSAs = [];

		if (
			user &&
			user.selectedAccountsAllPriceSources &&
			user.selectedAccountsAllPriceSources.responseObject
		) {
			allSAs = user.selectedAccountsAllPriceSources.responseObject;
		}
		const validDropdownSAs = allSAs.filter(function (itm) {
			return (
				itm["Quote Type"] === "N" &&
				itm.STATUS === "ACTIVE" &&
				itm.AGREEMENT_TYPE !== "GEA Parts" &&
				itm.AGREEMENT_TYPE !== "GEA FS Standard Agreement" &&
				itm.PRICE_LIST_NAME !== "APPLIANCES - BLEM LOAD PRICE LIST" &&
				itm["Price Communication Template"] !== "None"
			);
		});
		let selectedSA = "";

		if (
			sessionSA &&
			validDropdownSAs.some(function (sa) {
				return sa.AGREEMENT_NUMBER === sessionSA.AGREEMENT_NUMBER;
			})
		) {
			selectedSA = sessionSA.AGREEMENT_NUMBER;
		}

		this.setState({ 
			selectedSA: selectedSA,
			selectedAgreementName : validDropdownSAs
		 });
		// 🔥 run same filtering when auto-selected
		if (selectedSA) {
			this.loadPriceSheetsForSA(selectedSA);
		}
	}


	handleOpenGeneratePriceSheetDialog = (item, e) => {
		e.preventDefault(); 
		this.setState({
			showGeneratePriceSheetDialog: true,
			selectedPriceSheet: item
		});
	};

	getMappedTemplateFromSA = (selectedSA) => {
		if (!selectedSA) {	return null;}
		var priceCommTemplate = selectedSA["Price Communication Template"];
		if (!priceCommTemplate) {	return null;}
		return SA_TEMPLATE_MAPPING[priceCommTemplate] || null;
	};

	handlePriceSourceChange = (e) => {
		const selectedAgreementNumber = e.target.value;

		this.setState({ selectedSA: selectedAgreementNumber });

		if (selectedAgreementNumber) {
			this.loadPriceSheetsForSA(selectedAgreementNumber);
		} else {
			this.setState({ priceSheets: [] });
		}
	};


	loadPriceSheetsForSA = (selectedAgreementNumber) => {
			const user = this.props.state.user;
			const {relationShipPartyList } = user;
			let allSAs = [];

			if (
				user &&
				user.selectedAccountsAllPriceSources &&
				user.selectedAccountsAllPriceSources.responseObject
			) {
				allSAs = user.selectedAccountsAllPriceSources.responseObject;
			}

			let selectedSATemplates = [];
			for (let i = 0; i < allSAs.length; i++) {
				if (String(allSAs[i].AGREEMENT_NUMBER) === String(selectedAgreementNumber)) {
					const template = allSAs[i]["Price Communication Template"];
					if (template) {
						if (Array.isArray(template)) {
							selectedSATemplates.push.apply(selectedSATemplates, template);
						} else {
							selectedSATemplates.push(template);
						}
					}
				}
			}

			let mappedTemplates = [];
			for (let j = 0; j < selectedSATemplates.length; j++) {
				const mapped = this.getMappedTemplateFromSA({
					"Price Communication Template": selectedSATemplates[j]
				});
				if (mapped) {
					mappedTemplates.push(mapped);
				}
			}

			mappedTemplates = mappedTemplates.filter(function (value, index, self) {
				return self.indexOf(value) === index;
			});
			let result = null;
			if (mappedTemplates.some(t => t.toLowerCase().includes('contract'))) {
				result = 'CONTRACT';
			} else if (mappedTemplates.some(t => t.toLowerCase().includes('retail'))) {
				result = 'RETAIL';
			}
			this.props.getPriceSheet("isSiteManagment=true", true, response => {
				const priceSheets = response.responseObject || [];
				const filteredPriceSheets = [];
				const monogramWholesaleSheets = priceSheets.filter(sheet => sheet.template_name === "MONOGRAM WHOLESALE");
				for (let k = 0; k < priceSheets.length; k++) {
					for (let m = 0; m < mappedTemplates.length; m++) {
						if (
							priceSheets[k].template_name &&
							priceSheets[k].template_name.toLowerCase() === mappedTemplates[m].toLowerCase()
						) {
							filteredPriceSheets.push(priceSheets[k]);
							break;
						}
					}
				}
			if(result === "RETAIL" && relationShipPartyList && relationShipPartyList.responseObject && _.some(relationShipPartyList.responseObject, {RELATIONSHIP_STATUS: 'A',RELATIONSHIPCODE: 'Monogram Reseller Member Of'	})){
				 filteredPriceSheets.push(...monogramWholesaleSheets);
			}else if(result === "CONTRACT" && relationShipPartyList && relationShipPartyList.responseObject && _.some(relationShipPartyList.responseObject, {RELATIONSHIP_STATUS: 'A',RELATIONSHIPCODE: 'Monogram Pref Buildr Member Of'	})){
				 filteredPriceSheets.push(...monogramWholesaleSheets);
			}
				this.setState({ priceSheets: filteredPriceSheets });
			});
		}
	handleGetHelpDocuments(docId, fileExtension, docName, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ''
		});
		self.props.getDocuments(`requestType=priceSheets&docId=${docId}&docName=${docName}&docType=${fileExtension}`, false, response => {
			if(!response.status) {
				self.setState({
					errorMessage: 'Error occured while fetching price sheet.'
				})
			} else {
				window.open(response.responseObject, '_blank');
			}
		});
	}
	
	componentDidUpdate(prevProps, prevState) {
		const prevUser = prevProps.state && prevProps.state.user;
		const currUser = this.props.state && this.props.state.user;

		const prevSessionSA = prevUser && prevUser.selectedPriceSource;
		const currSessionSA = currUser && currUser.selectedPriceSource;

		if (prevSessionSA !== currSessionSA) {
			let allSAs = [];
			if (
				currUser &&
				currUser.selectedAccountsAllPriceSources &&
				currUser.selectedAccountsAllPriceSources.responseObject
			) {
				allSAs = currUser.selectedAccountsAllPriceSources.responseObject;
			}
			const validDropdownSAs = allSAs.filter(function (itm) {
				return (
					itm["Quote Type"] === "N" &&
					itm.STATUS === "ACTIVE" &&
					itm.AGREEMENT_TYPE !== "GEA Parts" &&
					itm.AGREEMENT_TYPE !== "GEA FS Standard Agreement" &&
					itm.PRICE_LIST_NAME !== "APPLIANCES - BLEM LOAD PRICE LIST" && itm["Price Communication Template"] !== "None"
				);
			});
			let newSelectedSA = "";
			if (
				currSessionSA &&
				validDropdownSAs.some(function (sa) {
					return sa.AGREEMENT_NUMBER === currSessionSA.AGREEMENT_NUMBER;
				})
			) {
				newSelectedSA = currSessionSA.AGREEMENT_NUMBER;
			}
			if (prevState.selectedSA !== newSelectedSA) {
				this.setState({ selectedSA: newSelectedSA });
				if (newSelectedSA) {
					this.loadPriceSheetsForSA(newSelectedSA);
				} else {
					this.setState({ priceSheets: [] });
				}
			}
		}
	}

	render() {
		const self = this;
		const { user } = self.props.state;
		const {selectedAgreementName} = self.state;

	    return (
			<div>
		        <h1 className="pageTitle" style={{margin: '21px 0'}}>Price Sheets</h1>
				 <p className="bold red">{this.state.errorMessage}</p>
		       <div className="searchResults">
                        <div>
                            <p className='bold'>{`Please select the Sales Agreement to generate your price sheet. An email will be sent to the address on your profile once the price sheet has been generated.`}</p>
							{ user.selectedAccountsAllPriceSources && user.selectedAccountsAllPriceSources.responseObject ?(user.selectedAccountsAllPriceSources.responseObject.length > 0
							?<p>
								<select 
								value={this.state.selectedSA}
        						id="selectPriceSourceD"
        						onChange={this.handlePriceSourceChange}
								name="selectPriceSourceD" 
								className="selectPriceSourceD" 
								style={{width: '40%'}}>
									<option value="">Select Sales Agreement</option>
									{user.selectedAccountsAllPriceSources.responseObject
										.filter((itm) => {
										return (
											itm["Quote Type"] === "N" &&                     // Quote Type = N
											itm.AGREEMENT_TYPE !== "GEA Parts" &&             // Exclude GEA Parts
											itm.STATUS === "ACTIVE" &&                        // Only active SAs
											itm.PRICE_LIST_NAME !== "APPLIANCES - BLEM LOAD PRICE LIST" &&
											itm.AGREEMENT_TYPE !== "GEA FS Standard Agreement" && // existing login exclusions
											itm["Price Communication Template"] !== "None"
										);
										})
										.map((item, index) => (
										<option value={item.AGREEMENT_NUMBER} key={index}>
											{item.DISPLAY_AGREEMENT_NAME}
										</option>  ))}
								</select>
							</p>
							:<p className="red bold">No sales agreements found for the given account.</p>
						)
						:null
					}
                            <table className="dataTable" width="100%">
        						<thead>
        							<tr>
        								<th>Price Sheet Name</th>
        								<th>Price Cycle Date</th>
										<th>Last Update</th>
        							</tr>
        						</thead>
        			            <tbody>
        							{this.state.priceSheets.map((item, index) => {
        								return <tr key={index}>
        			  	                	<td><a href="" 
											 onClick={this.handleOpenGeneratePriceSheetDialog.bind(this, item)}
											>{item.template_name}</a></td>
        			  	                	<td style={{width: '20%'}}>{item.effective_date}</td>
											<td style={{width: '20%'}}>{item.last_update_date}</td>
        			  	              	</tr>
        							})}
        						</tbody>
        					</table>
                        </div>
		          	<div className="clear" />
				</div>
				{this.state.showGeneratePriceSheetDialog && (<GeneratePriceSheetDialog {...this.props.state} open={this.state.showGeneratePriceSheetDialog} selectedAgreementName = {selectedAgreementName} priceSheet={this.state.selectedPriceSheet} selectedSA={this.state.selectedSA} onClose={() => this.setState({  showGeneratePriceSheetDialog: false, selectedPriceSheet: null }) }  
				 onContinue={() => this.setState({ showGeneratePriceSheetDialog: false, showConfirmationDialog: true })}/>)}
				{this.state.showConfirmationDialog && (<ConfirmationPriceSheetDialog open={this.state.showConfirmationDialog} onOk={() => this.setState({ showConfirmationDialog: false })
    }
  />
)}
			</div>
	    );
  	}
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
	getPriceSheet: (queryString, showLoader, callback) => dispatch(getPriceSheet(queryString, showLoader, callback)),
});

PriceSheets = connect(mapStateToProps, mapDispatchToProps)(PriceSheets);
export default PriceSheets;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/PriceSheets/index.js